import React from 'react';
import Typography from './Typography';
import timebg from '../images/Subtract.png';

const TimeList = ({ title, content, className, icon }) => {
    return (
        <div className={`flex flex-col gap-2 my-4 ${className && className}`}>
            <div className="relative max-w-[46px] max-h-[46px]">
                <img src={timebg} alt='timebg' className='absolute top-0 left-0 w-full h-full' />
                <div className="relative z-10 flex items-center justify-center h-full text-white">
                    {title && <Typography color={'#FFF'} size={'24px'} family={'Supply'} weight={400} lineheight={'170%'} text={title} />}
                </div>
            </div>
            <div className='text-center text-white opacity-60' >
                {content && <Typography color={'#FFF'} text={content} family={'Supply'} size={'12px'} weight={400} lineheight={'170%'} />}
            </div>
        </div>
    );
};

export default TimeList;